import styled, { css } from 'styled-components';
/**
 * Тип разделителя
 */
export type DividerType = 'shadow' | 'solid';

/**
 * Заданные цвета разделителя
 */
export const DividerColorEnum = {
  gray: '#adb8c3',
  light: '#c0ccd7'
} as const;

export type DividerProps = {
  /**
   * Тип
   */
  type?: DividerType;
  /** Высота */
  height?: string;
  /**
   * Основной цвет
   * Может быть значением из enum,
   * а может быть произвольным цветом
   */
  color?: keyof typeof DividerColorEnum | string;
};

function getColor(color?: string) {
  return (color && DividerColorEnum[color as keyof typeof DividerColorEnum]) || color;
}

/**
 * Компонент разделитель
 * Необходим для разделения частей интерфейса
 */
const Divider = styled.hr.attrs<DividerProps>((props) => ({
  type: props.type || 'solid'
}))<DividerProps>`
  border: none;
  margin: 0;
  ${props =>
    props.type === 'solid' &&
    css`
      height: ${props.height || '1px'};
      background: ${getColor(props.color) || '#adb8c3'};
    `};
  ${props =>
    props.type === 'shadow' &&
    css`
      height: ${props.height || '10px'};
      background: linear-gradient(
        180deg,
        ${getColor(props.color) || '#dee5eb'} 0%,
        rgba(255, 255, 255, 0) 100%
      );
    `};
`;

export default Divider;
